import Joyride, { STATUS } from 'react-joyride'
import JoyrideMessage from './JoyrideMessage'
import JoyrideStyles from './JoyrideStyles'

const steps = [
  {
    target: 'nav',
    content: (
      <JoyrideMessage
        title='Du hast nun das gesamte Dashboard freigeschaltet!'
        description='Hier in der linken Leiste findest du alle Bereiche des Dashboards. Erkunde die verschiedenen Funktionen und nutze Aivy optimal für deine Talentsuche!'
      />
    ),
    placement: 'right',
    disableBeacon: true
  }
]

const DashboardUnlockedJoyride = ({ run, onClose }) => (
  <Joyride
    steps={steps}
    run={run}
    continuous
    scrollToFirstStep
    showSkipButton={false}
    showProgress={false}
    styles={{
      tooltip: {
        maxWidth: '280px'
      },
      options: {
        zIndex: 10000
      },
      ...JoyrideStyles
    }}
    locale={{
      last: 'Fertig',
      skip: 'Überspringen',
      next: 'Weiter',
      back: 'Zurück'
    }}
    callback={({ status }) => {
      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        onClose?.()
      }
    }}
  />
)

export default DashboardUnlockedJoyride

